<div class="card card-custom">
  <div class="card-header">
    <h4 class="m-0">
      <span>{{ 'TABLE.DUPLICATE' | translate }}:</span>
      <span class="text-muted font-weight-normal ml-2">{{ template.name }}</span>
    </h4>
  </div>
  <div class="card-body">
    <mat-form-field appearance="standard" class="w-100">
      <mat-label>{{ 'TASK_TEMPLATE.NEW_NAME' | translate }}</mat-label>
      <input matInput [formControl]="nameCtrl" required />
      <mat-error *ngIf="nameCtrl.hasError('required')">{{
        'TASK_TEMPLATE.VALIDATION.REQUIRED'
          | translate : { label: 'TASK_TEMPLATE.NEW_NAME' | translate }
      }}</mat-error>
    </mat-form-field>
  </div>
  <div class="card-footer justify-content-end">
    <button mat-raised-button type="button" class="btn btn-sm btn-light" (click)="close($event)">
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      type="button"
      class="btn btn-sm btn-primary ml-15px"
      (click)="save($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
